
// define a mixin object
export const hoverDisplayMixins = {
  data() {
    return {
      hoverProperties: {
        currentHover: 'default',

        default: {
          state: false,
          ratingList: {},
          data: null,
          mouseX: 0,
          mouseY: 0,
        },

        feedback_interviewer: {
          state: false,
          ratingList: {
            'attitude': { label: 'Attitude' },
            'communication': { label: 'Communication' },
            'culture': { label: 'Culture' },
            'experience': { label: 'Experience' },
            'skills': { label: 'Skills' },
          },
          data: null,
          mouseX: 0,
          mouseY: 0,
        },

        feedback_applicant: {
          state: false,
          ratingList: {
            'applicant_rating': { label: 'Applicant Rating' },
          },
          data: null,
          mouseX: 0,
          mouseY: 0,
        },

        match_rate: {
          state: false,
          data: null,
          mouseX: 0,
          mouseY: 0,
        },
      }
    }
  },

  computed: {
    floatingDivStyle() {
      // Adjust the offset (e.g., +15px) so the div is not directly under the cursor
      const offsetX = 0;
      const offsetY = -20;

      return {
        display: this.hoverProperties[this.hoverProperties.currentHover].state ? 'block' : 'none', // Control visibility via style
        left: `${this.hoverProperties[this.hoverProperties.currentHover].mouseX + offsetX}px`,
        top: `${this.hoverProperties[this.hoverProperties.currentHover].mouseY + offsetY}px`,
      }
    },
  },

  methods: {
    showHover(element, item, state, event) {
      this.hoverProperties.currentHover = element
      this.hoverProperties[element].state = state
      this.hoverProperties[element].data = item

      this.handleHoverMouseMove(event)
    },

    handleHoverMouseMove(event) {
      // Update mouse coordinates
      this.hoverProperties[this.hoverProperties.currentHover].mouseX = event.clientX
      this.hoverProperties[this.hoverProperties.currentHover].mouseY = event.clientY
    },
  },
}
